import React from "react";

import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../_metronic/_partials/controls";
import {  CategoryTable } from "./category-table/CategoryTable";

export default function CategoriesCard() {
 
  return (
    <Card>
          <CardHeader title='Shopify Categories'>
            <CardHeaderToolbar>
             
            </CardHeaderToolbar>
          </CardHeader>{" "}
      <CardBody>
        <CategoryTable />
      </CardBody>
    </Card>
  );
}
